import { render, staticRenderFns } from "./DsnRow.vue?vue&type=template&id=087ed5d5&"
import script from "./DsnRow.vue?vue&type=script&lang=js&"
export * from "./DsnRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports